import { createSlice } from "@reduxjs/toolkit";
import { TOKEN_KEY, USER_KEY } from "../../services";

const readUser = () => {
    try {
        const saved = localStorage.getItem(USER_KEY);
        return saved ? JSON.parse(saved) : null;
    } catch (error) {
        return null;
    }
};

const token = localStorage.getItem(TOKEN_KEY) || "";

// The signed-in shopper, kept in localStorage (gn_user) so a refresh keeps them signed in
const authSlice = createSlice({
    name: "auth",
    initialState: {
        token,
        user: token ? readUser() : null,
        isAuthenticated: Boolean(token),
    },
    reducers: {
        // payload: { token, user } as returned by login / register
        loginSuccess: (state, action) => {
            state.token = action.payload.token;
            state.user = action.payload.user;
            state.isAuthenticated = true;
            localStorage.setItem(TOKEN_KEY, action.payload.token);
            localStorage.setItem(USER_KEY, JSON.stringify(action.payload.user));
        },
        // Replaces the saved profile with what the server returned
        updateUser: (state, action) => {
            state.user = { ...state.user, ...action.payload };
            localStorage.setItem(USER_KEY, JSON.stringify(state.user));
        },
        logout: (state) => {
            state.token = "";
            state.user = null;
            state.isAuthenticated = false;
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(USER_KEY);
        },
    },
});

export const { loginSuccess, updateUser, logout } = authSlice.actions;
export const selectCurrentUser = (state) => state.auth.user;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;

export default authSlice.reducer;
